import React, { useContext } from 'react';
import styled from 'styled-components';
import LazyLoad from 'react-lazy-load';
import logo from '../../assets/images/lablec_logo.png';
import { AppContext } from '../../context/appContext';

const Footer = () => {
  const [settings] = useContext(AppContext);
  return (
    <LazyLoad debounce={false} offsetVertical={700}>
      <Root bgcolor={settings?.footerBackground || `#001524`}>
        <LogoLine>
          <div className="center">
            <img
              src={
                settings?.footerLogo ? `upload/${settings.footerLogo}` : logo
              }
              alt="logo"
            />
          </div>
        </LogoLine>
        <Divider />
        <Copyright
          bgcolor={settings?.copyrightBackground || 'inherit'}
          color={settings?.copyrightColor || 'rgba(255, 255, 255, 0.63);'}
        >
          <div>
            <p>
              Minden jog fenntartva © {new Date().getFullYear()} |{` `}
              {settings?.title || '#Érintésmentes'}
            </p>
          </div>
        </Copyright>
      </Root>
    </LazyLoad>
  );
};

export default Footer;

const Root = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${props => props.bgcolor};
  color: white;
  width: 100%;
  flex-wrap: wrap;

  & > div {
    display: flex;
    justify-content: center;
    width: 100%;

    @media (max-width: 700px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    & > * {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @media (max-width: 700px) {
        width: 100%;
        align-items: center;
        justify-content: space-between;
        padding: 2em 0;
      }

      & > p {
        margin: 0;
        color: rgba(255, 255, 255, 0.63);
      }
    }

    & .center {
      display: flex;
      justify-content: center;
      align-items: center;

      & div {
        width: 75%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    & .right {
      text-align: right;
    }

    & img {
      width: 100%;
      width: 180px;
      height: auto;
      margin: 0 auto;
    }
  }

  & footer {
    display: flex;
    width: 100%;
    justify-content: space-around;

    @media (max-width: 900px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    & > div > p {
      width: 100%;

      @media (max-width: 900px) {
        width: 100%;
        font-size: 0.85em;
      }

      @media (max-width: 900px) {
        width: 100%;
        font-size: 0.6em;
      }
    }
  }
`;

const LogoLine = styled.div`
  padding: 3em 0;
`;

const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid #3d3d3d;
`;

const Copyright = styled.footer`
  background-color: ${props => props.bgcolor};
  height: 100%;
  padding: 3em 0;
  color: ${props => props.color};
`;
